export default "__VITE_ASSET__40cf256b__"